import Image from 'next/image';
import { useConfigProvider } from '@/lib/context';
import { imgix } from '@/shared/utils/utils';
import './index.less';

const Hero = () => {
  const { isMobile } = useConfigProvider();
  const image1 =
    'https://static.pietrastudio.com/public/file_uploads/9e4e86f340595da744fa8048e6f14811.png';
  const image2 =
    'https://static.pietrastudio.com/public/file_uploads/4e5fe2c5cd729521497d82a805fd88f3.png';

  return (
    <div className="designer-hero">
      <Image
        className="bottom-left"
        src={imgix(image1, { h: isMobile ? 200 : 375, dpr: 2, q: 100 })}
        alt="Browse Creator Marketplace"
        title="Browse Creator Marketplace"
        width={isMobile ? 200 : 375}
        height={isMobile ? 200 : 375}
      />
      <Image
        className="top-right"
        src={imgix(image2, { h: isMobile ? 200 : 375, dpr: 2, q: 100 })}
        alt="Browse Creator Marketplace"
        title="Browse Creator Marketplace"
        width={isMobile ? 200 : 375}
        height={isMobile ? 200 : 375}
      />
      <div className="hero-content">
        <span className="title">Browse Creator Marketplace</span>
        <div className="description">
          Discover creator-led brands and support their small businesses.
        </div>
      </div>
    </div>
  );
};

export default Hero;
